import React from 'react';
import { useRecordContext } from 'react-admin';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

import IconButton from '../../common/buttons/IconButton';

import { API_URL } from '../../../services/settings';

const DownloadACKButton = () => {
    const record = useRecordContext();

    if (!record?.has_ack) {
        return null;
    }

    return (
        <IconButton
            icon={<CheckCircleIcon />}
            component="a"
            target="__blank"
            href={`${API_URL}/invoices/${record?.id}/ack.xml`}
        >
            ACK
        </IconButton>
    );
};

export default DownloadACKButton;
